import { render, staticRenderFns } from "./start.vue?vue&type=template&id=adcbece4&scoped=true&"
import script from "./start.vue?vue&type=script&lang=js&"
export * from "./start.vue?vue&type=script&lang=js&"
import style0 from "./start.vue?vue&type=style&index=0&id=adcbece4&prod&lang=css&"
import style1 from "./start.vue?vue&type=style&index=1&id=adcbece4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adcbece4",
  null
  
)

export default component.exports